import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ADMIN_MARKET_COUNTRIES } from "./adminMarketCountries";
import { BUSINESS_TYPE_OPTIONS } from "./adminEnumLabels";

export const ALL_COUNTRIES = "";
export const ALL_BUSINESS_TYPES = "";

export interface AdminScopeFilterValues {
  countryCode: string;
  businessType: string;
}

interface Props {
  values: AdminScopeFilterValues;
  onChange: (next: AdminScopeFilterValues) => void;
  periodControl?: React.ReactNode;
  showCountry?: boolean;
  showIndustry?: boolean;
}

const filterControlSx = {
  minWidth: { xs: "100%", sm: 160 },
  width: { xs: "100%", sm: "auto" },
};

const AdminScopeFilters: React.FC<Props> = ({
  values,
  onChange,
  periodControl,
  showCountry = true,
  showIndustry = true,
}) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: 1.5,
      flex: 1,
      minWidth: 0,
    }}
  >
    {showCountry && (
      <FormControl size="small" sx={filterControlSx}>
        <InputLabel>Country</InputLabel>
        <Select
          value={values.countryCode}
          label="Country"
          onChange={(e) =>
            onChange({ ...values, countryCode: e.target.value as string })
          }
        >
          <MenuItem value={ALL_COUNTRIES}>All countries</MenuItem>
          {ADMIN_MARKET_COUNTRIES.map((c) => (
            <MenuItem key={c.code} value={c.code}>
              {c.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
    {showIndustry && (
      <FormControl size="small" sx={filterControlSx}>
        <InputLabel>Industry</InputLabel>
        <Select
          value={values.businessType}
          label="Industry"
          onChange={(e) =>
            onChange({ ...values, businessType: e.target.value as string })
          }
        >
          <MenuItem value={ALL_BUSINESS_TYPES}>All industries</MenuItem>
          {BUSINESS_TYPE_OPTIONS.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
    {periodControl && (
      <Box sx={{ flexShrink: 0, alignSelf: "flex-end" }}>{periodControl}</Box>
    )}
  </Box>
);

export default AdminScopeFilters;

export function AdminScopeFilterLegend() {
  return (
    <>
      Country = company registered market · Industry = plan business type on
      subscriptions and payments
    </>
  );
}

/** @deprecated Use AdminScopeFilters directly — it includes its own flex layout */
export function AdminScopeFiltersRow({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
